// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5":"8804e7ecf762f430a93f","11":"4899d05bf51a5511452e"}[chunkId] + ".css";
};